// Date/time display helpers pinned to Eastern Time (America/New_York).
// The Local Loot is an East-Tennessee brand — every user-facing timestamp
// should show in EST/EDT regardless of the viewer's browser timezone.

const TZ = "America/New_York";

/** Format an ISO (or Date) as "Apr 22, 2026, 8:27 AM" in ET. */
export function fmtEstDateTime(iso) {
  if (!iso) return "";
  const d = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("en-US", {
    timeZone: TZ,
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

/** Format as "8:27 AM" in ET. */
export function fmtEstTime(iso) {
  if (!iso) return "";
  const d = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("en-US", {
    timeZone: TZ,
    hour: "numeric",
    minute: "2-digit",
  });
}

/** Format as "Apr 22, 2026" in ET. */
export function fmtEstDate(iso) {
  if (!iso) return "";
  const d = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("en-US", {
    timeZone: TZ,
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/**
 * Convert a datetime-local input string (interpreted as ET wall clock)
 * into a UTC ISO string suitable for the backend.
 * Example: "2026-05-01T14:00" (EDT) -> "2026-05-01T18:00:00.000Z"
 * Returns "" when input is empty/invalid.
 */
export function etLocalToIso(localStr) {
  if (!localStr) return "";
  const fakeUtc = new Date(localStr + "Z");
  if (Number.isNaN(fakeUtc.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: TZ,
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
    hour12: false,
  }).formatToParts(fakeUtc).reduce((a, p) => { a[p.type] = p.value; return a; }, {});
  const hour = parts.hour === "24" ? "00" : parts.hour;
  const etAsUtc = Date.UTC(
    +parts.year, +parts.month - 1, +parts.day,
    +hour, +parts.minute, +parts.second || 0,
  );
  const offsetMs = fakeUtc.getTime() - etAsUtc;
  return new Date(fakeUtc.getTime() + offsetMs).toISOString();
}

/**
 * Convert a UTC ISO string into an ET datetime-local input value.
 * Example: "2026-05-01T18:00:00.000Z" -> "2026-05-01T14:00"
 */
export function isoToEtDatetimeLocal(iso) {
  if (!iso) return "";
  const d = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: TZ,
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit",
    hour12: false,
  }).formatToParts(d).reduce((a, p) => { a[p.type] = p.value; return a; }, {});
  const hour = parts.hour === "24" ? "00" : parts.hour;
  return `${parts.year}-${parts.month}-${parts.day}T${hour}:${parts.minute}`;
}
